import { Feature, RenderOn } from '@econsult/econsult-ui/dist/components/FlagControlledFeature/index';
import { STRINGS } from 'config';
import React from 'react';
import Snomed from './Snomed';
import { Divider, SnomedContainer } from './styles';
import Vitals from './Vitals';

const {
  CUSTOMISATION: { FEATURE_FLAGS },
} = STRINGS;

const SnomedBar: React.FC = () => (
  <Feature flags={[FEATURE_FLAGS.TEMP_SUMMARISER_SNOMED_ENABLED]}>
    <RenderOn>
      <SnomedContainer data-automation="SnomedContainer">
        <Vitals />
        <Divider />
        <Snomed />
      </SnomedContainer>
    </RenderOn>
  </Feature>
);

export default SnomedBar;
